export const Lotties = {
  APPROVED: require('../../assets/lotties/approved.json'),
  HOLD_ON: require('../../assets/lotties/hold_tight_animation.json'),
  LOADING_BUTTON: require('../../assets/lotties/loadingButton.json'),
  SUCCESS_ICON: require('../../assets/lotties/success-icon.json'),
};
